export enum KambiOddsFormatTypes {
  DECIMAL = 'decimal',
  FRACTIONAL = 'fractional',
  AMERICAN = 'american',
}
